const EditOutlineIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m21.113 4.123-1.236-1.236a2.75 2.75 0 0 0-3.889 0L3.311 15.564l-1.229 6.354 6.354-1.229L21.113 8.012a2.75 2.75 0 0 0 0-3.889Zm-1.061 2.829-1.271 1.271-3.004-3.004 1.271-1.271a1.25 1.25 0 0 1 1.768 0l1.236 1.236a1.25 1.25 0 0 1 0 1.768ZM17.72 9.284 7.7 19.304l-3.724.72.72-3.724 10.02-10.02 3.004 3.004Z" />
    </svg>

  );
};

export default EditOutlineIcon;
